import Vue from "vue";
import App from "./App.vue";
import {
  router,
  initGlobalComponents,
  initFilters,
  initPlugins
} from "./providers";

import store from "@/store";
import { i18n } from "@v2/shared/config";

initFilters();
initGlobalComponents();
initPlugins();

Vue.config.productionTip = false;

export const application = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
});
